const TypingIndicator = ({ label = "Bodhi is thinking" }) => (
	<div className="bodhi-float__typing">
		<span className="bodhi-float__typing-label">{label}</span>
		<span className="bodhi-float__typing-dots">
			<span className="bodhi-float__typing-dot" />
			<span className="bodhi-float__typing-dot" />
			<span className="bodhi-float__typing-dot" />
		</span>
	</div>
);

export default TypingIndicator;
